import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[_c(VRow,[_c(VCol,{attrs:{"cols":"9"}},[_c('vue-apex-charts',{attrs:{"id":"chart","width":"100%","height":"100","type":"bar","options":_vm.chartOptions,"series":_vm.chartSeries}})],1),_c(VCol,{attrs:{"cols":"3"}},[_c('pie-metric',{staticStyle:{"padding-top":"16px","margin-left":"-35px"},attrs:{"value":_vm.data.variability,"color":this.$vuetify.theme.themes.light.primary,"width":80,"height":80,"font-size":18}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }